import { render, staticRenderFns } from "./AdminPurchase.vue?vue&type=template&id=5afd0d04&scoped=true&"
import script from "./AdminPurchase.vue?vue&type=script&lang=js&"
export * from "./AdminPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd0d04",
  null
  
)

export default component.exports